import { render, staticRenderFns } from "./AddDocumentSeriesModal.vue?vue&type=template&id=03f19360&"
import script from "./AddDocumentSeriesModal.vue?vue&type=script&lang=js&"
export * from "./AddDocumentSeriesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports